import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#777e90",
      "fill-rule": "evenodd",
      d: "M11.992 4.171 12 4.167l.009.004 4.453 2.672L18 7.77V18.8c0 .593-.002.918-.02 1.15l-.003.027-.026.002c-.233.02-.558.021-1.151.021H7.2c-.593 0-.918-.002-1.15-.02l-.027-.003-.002-.026C6 19.718 6 19.393 6 18.8V7.77l1.532-.923zm-5.49.962-5.016 3.01a1 1 0 0 0 1.029 1.714L4 8.967V18.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 22 6.08 22 7.2 22h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V8.966l1.485.891a1 1 0 1 0 1.03-1.715L17.493 5.13 13.65 2.815c-.279-.168-.493-.297-.675-.394a2 2 0 0 0-.129-.067 1.8 1.8 0 0 0-.417-.152 2 2 0 0 0-.86 0c-.135.03-.267.079-.418.153q-.064.03-.127.065c-.182.097-.396.226-.676.395z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#777e90",
      "fill-rule": "evenodd",
      d: "M13 20v-4a1 1 0 1 0-2 0v4zm-1-7a3 3 0 0 0-3 3v6h6v-6a3 3 0 0 0-3-3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }